import React, { useState, createContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { submitOtp, getOtp } from "../../../../apis/Api";
import { useLocation } from "react-router-dom";
import RouteConstant from "../../../../constants/routesContent.json";
import LoginConstants from "../../../../constants/contentFile.json";
import { validateRegesterdMobileNumber } from "../../../../utils/service";
import { useCookies } from "react-cookie";

export const LoginOtpContext = createContext({});
export const LoginOtpContextProvider = ({ children }) => {
  const [otp, setOtp] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const loginContent = LoginConstants.errorMessages;
  const otpContent = LoginConstants.loginPage;
  const [cookies, setCookie] = useCookies(["user"]);
  const [timeOutTrigger, setTimeOutTrigger] = useState(false);
  const [otpTimeOut, setOtpTimeOut] = useState(0);
  const [apiStatus, setApiStatus] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const mobileNumber = location.state.regMobileNumber;
  const successOtp = location.state.isOtpSuccess;
  const token = location.state.token;
  const otpMessage = otpContent.otpSuccess;

  const handleChange = (enteredOtp) => {
    setOtp(enteredOtp.toString());
  };
  const goBack = () => {
    navigate(-1);
  };
  useEffect(() => {
    if (successOtp == true) {
      setAlertMessage(otpMessage);
      setShowAlert(true);
      setTimeOutTrigger((prev) => !prev);
      setOtpTimeOut(60);
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(
      () => setOtpTimeOut((prev) => (prev - 1 >= 0 ? prev - 1 : 0)),
      1000,
    );

    return () => clearInterval(interval);
  }, [timeOutTrigger]);

  const onSubmitClik = async () => {
    if (otpTimeOut > 0) {
      setAlertMessage(otpContent.resendAlert);
      setShowAlert(true);
    } else if (
      mobileNumber.toString().length == 10 &&
      validateRegesterdMobileNumber(mobileNumber)
    ) {
      setApiStatus("fetching");
      try {
        const getOtpData = await getOtp(mobileNumber, token);
        if (getOtpData?.data?.statusCode == 200) {
          setAlertMessage(otpMessage);
          setShowAlert(true);
          setOtp("");
          setTimeOutTrigger((prev) => !prev);
          setOtpTimeOut(60);
        }
      } catch (error) {
        if (error?.response?.data?.statusCode === 400) {
          const errorMessage = error.response.data.statusMessage;
          navigate(RouteConstant.LINK_EXPIRED, { state: errorMessage });
        } else {
          setAlertMessage(loginContent.somethingWrong);
          setShowAlert(true);
        }
      }
      setApiStatus("completed");
    } else {
      setShowAlert(true);
      setAlertMessage(loginContent.enterValidNumber);
    }
  };
  const loginOnSubmit = async () => {
    const loginPayload = {
      mob: mobileNumber,
      otp: otp,
    };
    setApiStatus("fetching");
    try {
      const submitOtpData = await submitOtp(loginPayload);
      if (submitOtpData?.data?.statusCode === 200) {
        console.log(submitOtpData.data, "submitOtpData");
        const token = submitOtpData.data["Access-Token"];
        const supplierId = submitOtpData.data["supplier_id"];
        const userId = submitOtpData.data["userId"];
        const isZonalHead = submitOtpData?.data["is_zonal_head"];

        setCookie("xAccessToken", token, { path: "/" });
        setCookie("supplierId", supplierId, { path: "/" });
        setCookie("userId", userId, { path: "/" });
        setCookie("isZonalHead", isZonalHead, { path: "/" });

        navigate(RouteConstant.ORDER_DETAILS);
      }
    } catch (error) {
      if (error?.response?.data?.statusCode === 400) {
        const errorMessage = error.response.data.statusMessage;
        setAlertMessage(errorMessage);
        setShowAlert(true);
      } else {
        setAlertMessage(loginContent.somethingWrong);
        setShowAlert(true);
      }
    }
    setApiStatus("completed");
  };

  const providerValue = {
    otp,
    handleChange,
    loginOnSubmit,
    goBack,
    showAlert,
    setShowAlert,
    alertMessage,
    setAlertMessage,
    onSubmitClik,
    otpTimeOut,
    apiStatus,
  };

  return (
    <LoginOtpContext.Provider value={providerValue}>
      {children}
    </LoginOtpContext.Provider>
  );
};
